import React from 'react';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { ThemeProvider } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './components/AuthProvider';
import AppContent from './components/AppContent';
import ErrorBoundary from './components/ErrorBoundary';
import theme from './common/theme/index';
import { msalConfig } from './common/auth/authConfig'; // Your MSAL configuration
import { SnackbarProvider } from './components/SnackbarProvider';
import { LanguageProvider } from './hooks/useTranslation';

const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  return (
    <ErrorBoundary>
      <LanguageProvider defaultLang="en">
        {' '}
        {/* or any other default language en , cn or es */}
        <MsalProvider instance={msalInstance}>
          <ThemeProvider theme={theme}>
            <BrowserRouter>
              <AuthProvider>
                <SnackbarProvider>
                  <AppContent />
                </SnackbarProvider>
              </AuthProvider>
            </BrowserRouter>
          </ThemeProvider>
        </MsalProvider>
      </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
